module.exports = __webpack_public_path__ + "img/9_of_Spades.svg.c977cb47.png";